import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'shared/UI/Checkbox'

const PrivacyMessageCheckbox = ({
  checkboxLabel,
  input: { onChange, value },
  className,
  themeColorHex
}) => {
  const handleClick = () => onChange(!value)

  return (
    <Checkbox
      className={`privacy-message-checkbox-container ${className || ''}`}
      label={checkboxLabel}
      checked={!!value}
      onClick={handleClick}
      checkmarkColor={themeColorHex} />
  )
}

PrivacyMessageCheckbox.propTypes = {
  checkboxLabel: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string
}

export default PrivacyMessageCheckbox